import React from "react";
import { Stack } from "@mui/material";

import { HubHookFormInput } from "../../components";
import { ReworkStationTable } from "../../tables";

import CreateReworkEmployeeId from "./CreateReworkEmployeeId";

const AddReworkRouteContentForm = () => {
  return (
    <Stack gap="15px" width="100%">
      <Stack direction="row" gap="15px">
        <CreateReworkEmployeeId />
        <HubHookFormInput
          name="quantity"
          label="Quantity (Cantidad)"
          placeholder="quantity"
          required
          isNumber
        />
      </Stack>
      <ReworkStationTable />
    </Stack>
  );
};

export default AddReworkRouteContentForm;
